import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { extractDate } from "../../../Components/Functions/date.fun";
import { Toast } from "../../../CustomComponent/toast";
import { useState } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import performRequest from "../../../api/request";
import LoadingPage from "../../../Components/layouts/loading";

const tableHead = [
  "Sr.",
  "Client Name",
  "date",
  "Sell Product",
  "Amount (-GST)",
  "incentive",
  "creator",
  "status",
  // "description",
  "Actions",
];

const getSell = (pro) => {
  if (pro === "hydroponic masterclass") {
    return "Hydroponic Masterclass";
  }
  if (pro === "practical training") {
    return "Practical Training";
  }
  if (pro === "physical site inspection") {
    return "Physical Site Inspection";
  }
  if (pro === "site inspection kit") {
    return "Site Inspection Kit";
  }
  if (pro === "aif project report") {
    return "AIF Project Report";
  }
  if (pro === "project conversion") {
    return "Project Conversion";
  }
  if (pro === "construction payment") {
    return "Construction Payment";
  }
  if (pro === "allother") {
    return "All other sales excluding CEA and Hydroponics";
  }
};

const IncentiveTable = ({ incentives = [], currentPage, itemsPerPage }) => {
  const user = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const goToEdit = (id) => {
    navigate(`/revenue-management/edit/${id}`);
  };
  const [incentivesNew, setIncentivesNew] = useState(incentives);

  const goToDelete = (id) => {
    setLoading(true);
    performRequest("DELETE", `/incentive/deleteIncentive/${id}`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Revenue deleted successfully!");
          setIncentivesNew((prev) => prev.filter((item) => item.id !== id));
        } else {
          Toast("error", "Error while getting PO!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {incentivesNew?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td style={{ maxWidth: "150px" }}>{item?.leadName || "N/A"}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td style={{ maxWidth: "200px" }}>
                  {item?.sellsType ? getSell(item?.sellsType) : "N/A"}
                </td>
                <td>
                  {item?.preGstAmount ? Math.round(item?.preGstAmount) : "N/A"}
                </td>
                <td>{roundOffCost(item?.preGstAmount * 0.0025)}</td>
                {/* <td>{roundOffCost(item?.payableIncentive)}</td> */}
                <td>{item?.generatedBy || "N/A"}</td>

                <td>{item?.revenueApproved}</td>
                <td>
                  <div className="d-flex">
                    {(user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                      user.Role === process.env.REACT_APP_ROLE_ADMIN ||
                      user.Role === process.env.REACT_APP_ROLE_ACCOUNTS) && (
                      <button
                        className="btn btn-sm px-3 btn-primary  m-1"
                        onClick={() => goToEdit(item.id)}
                      >
                        Edit
                      </button>
                    )}{" "}
                    {user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    user.Role === process.env.REACT_APP_ROLE_ADMIN ? (
                      <button
                        disabled={
                          item?.revenueApproved === "Approved" ||
                          item.revenueApproved === "Denied"
                        }
                        className="btn btn-sm px-3 btn-danger m-1"
                        onClick={() => goToDelete(item.id)}
                      >
                        Delete
                      </button>
                    ) : item?.generatedById == user?.UserId ? (
                      <button
                        disabled={
                          item?.revenueApproved === "Approved" ||
                          item.revenueApproved === "Denied"
                        }
                        className="btn btn-sm px-3 btn-danger m-1"
                        onClick={() => goToDelete(item.id)}
                      >
                        Delete
                      </button>
                    ) : (
                      "N/A"
                    )}
                  </div>

                  <button
                    className="btn btn-sm px-3 btn-primary m-1"
                    onClick={() =>
                      navigate(
                        `/revenue-management/payment-receipt/${item?.id}`
                      )
                    }
                    disabled={item?.revenueApproved !== "Approved"}
                  >
                    Payment receipt
                  </button>
                </td>
                {/* <td>
                  { item?.generatedById == user?.UserId ?<button
                      disabled={item?.revenueApproved === "Approved"}
                      className="btn btn-sm px-3 btn-danger"
                      onClick={() => goToDelete(item.id)}
                    >
                      Delete
                    </button>:"N/A"}
                  </td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default IncentiveTable;
